import styled from 'styled-components'

const FlyoutContent = styled.div`
  padding: 24px;
`

export default FlyoutContent